export const USER_LIST = "USER_LIST";
export const USER_PAGINATION = "USER_PAGINATION";
export const USER_DROPDOWN_BY_COMPANY_N_ROLE =
    "USER_DROPDOWN_BY_COMPANY_N_ROLE";
export const CLEAR_USER_LIST = "CLEAR_USER_LIST";
